import type React from 'react';

import type { Text } from '@zillow/constellation';
import { FormField, Label, Spacer, Textarea } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import type { HTMLElementEvent } from '../../../../models/Types';
import { LANDSCAPING } from '../../../../constants';
import Landscaping_v1 from './Landscaping_v1';
import OptionSelector from '../Utilities/OptionSelector';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function Landscaping_v2({ section, setSectionValues }: Props): JSX.Element {
  function setOption1(): void {
    setSectionValues({
      [LANDSCAPING.FIELD_NAME.TENANT_RESPONSIBILITY]: true,
      [LANDSCAPING.FIELD_NAME.LANDLORD_RESPONSIBILITY]: false,
      [LANDSCAPING.FIELD_NAME.IS_ENABLED]: true,
      [LANDSCAPING.FIELD_NAME.SERVICES]: '',
    });
  }

  function setOption2(): void {
    setSectionValues({
      [LANDSCAPING.FIELD_NAME.TENANT_RESPONSIBILITY]: false,
      [LANDSCAPING.FIELD_NAME.LANDLORD_RESPONSIBILITY]: true,
      [LANDSCAPING.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function setServices(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [LANDSCAPING.FIELD_NAME.SERVICES]: event.currentTarget.value,
    });
  }

  function renderOption2Details(): React.ReactNode {
    return (
      <FormField>
        <Label id="services-provided">What services will be provided?</Label>
        <Textarea
          aria-labelledby="services-provided"
          resize="vertical"
          placeholder="(example: Front lawn trimming, back yard weed removal)"
          value={section.getFieldValue(LANDSCAPING.FIELD_NAME.SERVICES)}
          onChange={setServices}
        />
      </FormField>
    );
  }

  function renderOptionSelector(): React.ReactNode {
    const landscaping_isEnabled = section.getFieldValue(LANDSCAPING.FIELD_NAME.IS_ENABLED);
    const option1Selected = section.getFieldValue(LANDSCAPING.FIELD_NAME.TENANT_RESPONSIBILITY);
    const option2Selected = section.getFieldValue(LANDSCAPING.FIELD_NAME.LANDLORD_RESPONSIBILITY);
    const option1Content = 'Responsible for reasonable upkeep including lawn mowing and leaf raking.';
    const option2Content = 'Responsible for reasonable upkeep including lawn mowing and leaf raking.';

    return (
      <>
        <OptionSelector
          disabled={!landscaping_isEnabled}
          optionsText="Who will be responsible for landscaping?"
          option1Selected={option1Selected}
          option1Content={option1Content}
          onOption1Click={setOption1}
          option2Selected={option2Selected}
          option2Content={option2Content}
          onOption2Click={setOption2}
        />
        {option2Selected && <Spacer marginTop="sm">{renderOption2Details()}</Spacer>}
      </>
    );
  }

  return <Landscaping_v1 section={section} setSectionValues={setSectionValues} customOption={renderOptionSelector()} />;
}

Landscaping_v2.description = 'Only asks for services provided';
